/**
 * Created by rathompson on 8/2/23
 * File: PanIpModal.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import type { VFC } from 'react'
import { useCallback } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalProps,
  Button
} from '@panwds/react-ui'
import {
  BUTTON_CANCEL
} from '../../../common/constants/LabelConstants'
import {
  BUTTON_OK,
  LABEL_PAN_HAS_TSG_ACCESS,
  TITLE_ARE_YOU_SURE
} from '../../constants/LabelConstants'

const PanIpModal: VFC<ModalProps & {
  closeModal: () => void,
  callback: any
}> = ({ closeModal, isOpen, callback }) => {

  const onOk = useCallback(() => {
    callback(true)
    closeModal()
  }, [closeModal, callback])

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      size='sm'
    >
      <ModalHeader title={TITLE_ARE_YOU_SURE}/>
      <ModalBody>
        {LABEL_PAN_HAS_TSG_ACCESS}
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={closeModal}
        >
          {BUTTON_CANCEL}
        </Button>
        <Button
          appearance='primary'
          onClick={onOk}
        >
          {BUTTON_OK}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default PanIpModal
